import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import PaginatedTable from 'src/components/ui/table/paginated-table';
import LinkTextField from 'src/components/widgets/link-textfield'
import HeaderTableCell from 'src/components/ui/table/header-table-cell';
import TableCellText from 'src/components/ui/table/table-cell-text.js';

export const ListTable = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    selected = [],
    onDetailClicked,
  } = props;

  return (
    <PaginatedTable
      items={dataStore.items}
      loading={dataStore.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      renderItem={(item, rowstyle) => (
        <TableRow hover selected={selected.includes(item.id)} sx={{rowstyle}}>
          <TableCellText sx={{ py: 2 }}>
            <LinkTextField value={item.courseName} onClick={() => onDetailClicked(item)} />
          </TableCellText>
          <TableCellText>{item.courseCode}</TableCellText>
          <TableCellText>{item.openingDay}</TableCellText>
          <TableCellText>{item.closingDay}</TableCellText>
          <TableCellText>{item.statusName}</TableCellText>
          <TableCellText fontWeight={500} align="right">
            {item.quantity}
          </TableCellText>
        </TableRow>
      )}
    >
      <TableRow>
        <HeaderTableCell sx={{ width: '18%' }}>Tên khóa</HeaderTableCell>
        <HeaderTableCell sx={{ width: '18%' }}>Mã khóa</HeaderTableCell>
        <HeaderTableCell sx={{ width: '18%' }}>Khai giảng</HeaderTableCell>
        <HeaderTableCell sx={{ width: '18%' }}>Bế giảng</HeaderTableCell>
        <HeaderTableCell sx={{ width: '20%' }}>Trạng thái</HeaderTableCell>
        <HeaderTableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>SL</HeaderTableCell>
      </TableRow>
    </PaginatedTable>
  );
};

ListTable.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
